import React, { useEffect } from "react";
import "../assets/vendor/bootstrap/css/bootstrap.min.css";
import "../assets/vendor/bootstrap-icons/bootstrap-icons.css";
import "../assets/vendor/aos/aos.css";
import "../assets/css/About2_custom.css"; // Import du CSS dédié
import profileImg from "../assets/img/profile.jpg";
import { useTranslation } from "react-i18next";

function About2() {
  const { t } = useTranslation();
  useEffect(() => {
    document.querySelectorAll(".circle-bar").forEach((circle) => {
      const value = parseInt(circle.getAttribute("data-value"), 10);
      const radius = 45;
      const circumference = 2 * Math.PI * radius;
      const offset = circumference - (value / 100) * circumference;

      circle.style.strokeDasharray = `${circumference} ${circumference}`;
      circle.style.strokeDashoffset = circumference;

      setTimeout(() => {
        circle.style.strokeDashoffset = offset;
      }, 300);
    });
  }, []);

  return (
    <section
      id="about2"
      style={{
        backgroundColor: "#ffffff",
        color: "#000",
        textAlign: "center",
        padding: "80px 0",
      }}
    >
      <div className="container" data-aos="fade-up" data-aos-delay="100">
        <div
          style={{
            width: "150px",
            height: "150px",
            borderRadius: "50%",
            display: "block",
            margin: "0 auto 20px auto",
            overflow: "hidden",
            border: "5px solid #ccc",
          }}
        >
          <img
            src={profileImg}
            alt="Profile"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          />
        </div>

        <h5 style={{ fontSize: "14px", textTransform: "uppercase", letterSpacing: "1px", color: "#0078ff" }}>
        {t("aboutme")}
        </h5>
        <h2 style={{ fontSize: "28px", fontWeight: "bold", marginBottom: "20px" }}>
        {t("aboutExperience")}
        </h2>
        <p
          style={{
            maxWidth: "600px",
            margin: "0 auto 30px auto",
            fontSize: "16px",
            lineHeight: "1.6",
            color: "#444",
          }}
        >
          {t("aboutprofil")}
        </p>

        {/* Skills Section */}
        <div className="circle-progress-container">
          {[
            { name: t("aboutAWS"), value: "95" },
            { name: t("aboutAutomatization"), value: "85" },
            { name: t("aboutDevWeb"), value: "80" },
            { name: t("aboutMonitoring"), value: "80" },
            { name: t("aboutFinOps"), value: "80" },
          ].map((skill, index) => (
            <div key={index} className="circle-skill">
              <div className="circle-progress">
                <svg width="100" height="100" viewBox="0 0 100 100">
                  {/* Fond gris */}
                  <circle cx="50" cy="50" r="45" className="circle-bg" />
                  {/* Progression animée */}
                  <circle
                    cx="50"
                    cy="50"
                    r="45"
                    className="circle-bar"
                    data-value={skill.value}
                  />
                </svg>
                <span className="circle-progress-value">{skill.value}%</span>
              </div>
              <p>{skill.name}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default About2;
